
const _BiomassLevel = {
	1: "Low",
	2: "Average",
	3: "High",
}
const _BiomassUnit = {
	1: "NDVI",
	2: "Leaf area index",
	3: "Yara Biomass index",
	4: "Chlorophyll content index",
	5: "Enhanced Vegetation Index",
}
const _BusinessId = {
	1: "Hutchinsons",
	2: "Farmacy plc",
	3: "CropWise",
	4: "Agrivice",
	5: "Vassgro",
	6: "Gardiner ICM",
	1000: "Cobb Agri",
	1001: "Wynnstay",
	1002: "Owen Farm Services",
	1003: "Boole Crop Specialists Ltd",
}
const _CropDisease = {
	1: "Mildew",
	2: "Yellow Rust",
	3: "Brown Rust",
	4: "Septoria Tritici",
	5: "Eyespot",
	6: "Rhynchosporium",
	7: "Net Blotch",
}
const _CropMaltingOption = {
	1: "Brewing",
	2: "Distilling",
}
const _CropProtectionStatus = {
	1: "Outdoor",
	2: "Permanent protection",
	3: "Temporary protection",
}
const _CropPurpose = {
	1: "Feed",
	2: "Malting",
	3: "Milling",
	4: "Dessert",
	5: "Culinary",
	6: "Cider",
	7: "Forage",
	14: "Grain",
	15: "Maincrop",
	16: "1st Early",
	17: "2nd Early",
	18: "Seed",
	19: "Winter",
	20: "Summer",
	21: "Wine",
	22: "Table",
	23: "Dry",
	24: "Fresh",
}
const _CropResidue = {
	1: "Incorporated",
	3: "Baled",
}
const _DiseaseSensitivity = {
	1: "Low",
	2: "Medium",
	3: "High",
	4: "Very High",
}
const _ExternalAppId = {
	1: "Omnia Connect",
	100: "Dropbox",
	101: "iSoyl",
	200: "John Deere",
	210: "Claas",
	220: "Climate FieldView",
	301: "Greenlight Grower Mananagement",
}
const _FertiliserAppUnit = {
	1: "kg",
	2: "t",
	3: "l",
	4: "m³",
}
const _FertiliserLiquidUnit = {
	1: "Weight for volume",
	2: "Weight for weight",
}
const _FieldAreaType = {
	1: "Whole area",
	2: "Working area",
	3: "Boundary area",
}
const _FieldDrainage = {
	1: "Land drains",
	2: "Mole drained",
	3: "No drainage",
}
const _GenericPlanUnitId = {
	1: "kg/ha",
	2: "t/ha",
	3: "l/ha",
	4: "m³/ha",
	5: "seeds/m²",
	6: "seeds/ha",
}
const _GrassCuts = {
	1: "1",
	2: "2",
	3: "3",
	999: "4 or more",
}
const _GrassManagementEngland = {
	1: "Cut",
	2: "Cut and grazed",
	3: "Intensive grazing",
	4: "Extensive grazing",
	5: "Natural / Semi-Natural",
	6: "Dehydrated",
	7: "Dehydrated with irrigation",
	8: "Seed",
	9: "Herbal Ley",
}
const _GrassManagementScotland = {
	100: "2 or 3 cut silage + grazing",
	101: "1 cut silage + grazing",
	102: "Grazing with low clover",
	103: "Hay + grazing",
	104: "Grass with high clover",
}
const _GrassNCropGroup = {
	201: "1-2 year low N leys, not grazed within 2 months of ploughing out or during September or October",
	300: "1-2 year low N leys, grazed within 2 months of ploughing out or during September or October",
	301: "1-2 year high N leys, not grazed within 2 months of ploughing out or during September or October",
	302: "Thin permanent grass, low N, no clover",
	401: "1-2 year high N leys, grazed within 2 months of ploughing out or during September or October",
	402: "3-5 year low N leys, not grazed within 2 months of ploughing out or during September or October",
	403: "Thick permanent grass, low N",
	501: "3-5 year high N leys, not grazed within 2 months of ploughing out or during September or October",
	502: "3-5 year low N leys, grazed within 2 months of ploughing out or during September or October",
	503: "Permanent grass, high N, not grazed within 2 months of ploughing out or during September or October",
	601: "3-5 year high N leys, grazed within 2 months of ploughing out",
	602: "Permanent grass, high N, grazed within 2 months of ploughing out",
}
const _GrassSiteClass = {
	1: "1",
	2: "2",
	3: "3",
	4: "4",
	5: "5",
}
const _GrowingSeasonLength = {
	1: "<60 days",
	2: "60-90 days",
	5: "60-90 days (ware)",
	6: "60-90 days (seed & punnets)",
	3: "90-120 days",
	4: ">120 days",
}
const _HeadlandIncreaseUnit = {
	1: "%",
	2: "seeds/m²",
	3: "kg/ha",
}
const _ImportHistoryProvider = {
	1: "Gatekeeper",
	2: "Muddy Boots",
	3: "Omnia",
	4: "Ag Leader",
	5: "Case IH / New Holland",
	6: "CLAAS",
	7: "FarmWorks",
	8: "John Deere",
	9: "ISO-XML",
	10: "CSV",
	11: "Shape file",
	12: "Plant Vision",
	13: "Yara",
	14: "Precision Decisions",
	15: "Lancrop",
	16: "NRM",
	17: "Richard Austin Agriculture",
	18: "RootPlanner",
	19: "RDS",
	20: "KML",
	21: "SOYL",
	22: "TerraMap",
	23: "RPA",
	24: "SSM",
	25: "Climate FieldView",
	26: "Rhiza",
	27: "FarmTRX",
	28: "ScotGov",
}
const _LayerTypeGroupId = {
	1: "Soil physical",
	2: "Soil analysis",
	3: "Yield",
	4: "Application plans",
	5: "Biomass",
	6: "TerraMap",
	7: "Weed and pest pressure",
	999: "Other",
}
const _LayerTypeId = {
	1: "Soil texture",
	2: "Subsoil texture",
	3: "Soil analysis",
	4: "EC scan",
	5: "PCN analysis",
	10: "P2O5",
	11: "K2O",
	12: "MgO",
	13: "pH",
	14: "Sand %",
	15: "Silt %",
	16: "Clay %",
	17: "Organic Matter %",
	18: "CEC",
	19: "Calcium",
	20: "Sodium",
	21: "Manganese",
	22: "Molybdenum",
	23: "Boron",
	24: "Copper",
	25: "Iron",
	26: "Zinc",
	27: "Sulphur",
	28: "Plant Available Water Index",
	29: "Elevation",
	30: "K:Mg Ratio",
	31: "Organic Carbon %",
	32: "Organic Carbon T/ha",
	33: "Active Carbon %",
	34: "Active Carbon T/ha",
	35: "% carbon that's active",
	36: "Silt/clay fraction",
	37: "SOC:Clay Ratio",
	38: "Total Calcium Kg/Ha",
	39: "Total Magnesium Kg/Ha",
	40: "Total Potash Kg/Ha",
	41: "Total Sodium Kg/Ha",
	42: "Total Sulphur Kg/Ha",
	43: "Total Phosphorus Kg/Ha",
	44: "Available Calcium Kg/Ha",
	45: "Available Magnesium Kg/Ha",
	46: "Available Potash Kg/Ha",
	47: "Available Sodium Kg/Ha",
	48: "Available Sulphur Kg/Ha",
	49: "Available Phosphorus Kg/Ha",
	50: "Buffer pH",
	51: "Total Ca : Total Mg Ratio",
	52: "Bulk Density",
	100: "Yield",
	101: "Field performance",
	102: "Yield trend",
	103: "Average yield",
	200: "Seed rate",
	201: "Slug pressure",
	202: "Weed pressure",
	203: "Seedbed condition",
	204: "Establishment %",
	300: "Biomass",
	400: "Nutrient requirements",
	500: "Nutrient applications",
	600: "Drawing layer",
	601: "Picture",
	700: "Generic product plan",
	710: "Prescription plan",
}
const _LayerTypeSubgroupId = {
	6001: "Standard elements",
	6002: "Soil properties",
	6003: "Additional elements",
	6004: "Total elements",
	6005: "Available elements",
	6999: "Other",
}
const _LimingFactor = {
	1: "Arable",
	2: "Grassland",
}
const _ManureAppMethod = {
	1: "Surface applied",
	2: "Incorporated within 24 hrs",
	3: "Incorporated within 6 hrs",
	4: "Band spread",
	5: "Shallow injected",
	6: "Deep injected",
}
const _ManureUnit = {
	2: "t",
	4: "m³",
}
const _NitrogenAnalysisType = {
	1: "NMIN",
	2: "SMN",
	3: "Farm assessment",
}
const _NitrogenSnsMethod = {
	1: "FarmAssessment",
	2: "NMIN",
	3: "SMN",
}
const _NLeafAnalysis = {
	1: "Too low",
	2: "Low",
	3: "Satisfactory",
	4: "High",
	5: "Too high",
}
const _NMaxGroupId = {
	1: "Winter Wheat",
	2: "Spring Wheat",
	3: "Winter Barley",
	4: "Spring Barley",
	5: "Winter Oilseed Rape",
	6: "Sugar Beet",
	7: "Potatoes",
	8: "Forage Maize",
	9: "Field Beans",
	10: "Peas",
	11: "Grass",
	12: "Horticultural Group 1",
	13: "Horticultural Group 2",
	14: "Horticultural Group 3",
}
const _NtrReqConfigMode = {
	1: "Whole field",
	2: "Precision",
	3: "Soil analysis only",
}
const _NutrientType = {
	1: "N",
	2: "SO3",
	3: "P2O5",
	4: "K2O",
	5: "MgO",
	6: "Lime",
}
const _OmniaModuleId = {
	1: "Fields",
	2: "Map layers",
	3: "Soil",
	4: "Stocks",
	5: "Seeds",
	6: "Nutrition",
	7: "Manure",
	8: "Field performance",
	9: "Reports",
	10: "Cost of production",
	11: "Imports",
	12: "Exports",
	13: "Climate",
	14: "App connections",
	15: "Holding",
	16: "User accounts",
	17: "Field diary",
	18: "Dashboard",
	19: "Satellite",
	20: "Shed",
	21: "Planning",
	22: "AsApplied",
	23: "Prescriptions",
	24: "Spray",
}
const _OmniaObjectType = {
	1: "Holding",
	2: "Field",
	3: "Cropping",
	4: "Cropping year",
	5: "Custom product",
	101: "Layer",
	102: "Yield map colours",
	103: "Generic plan",
	201: "Soil anlaysis",
	202: "Nitrogen anlaysis",
	203: "PCN anlaysis",
	204: "Healthy soil assessment",
	301: "Seed stock",
	302: "Fertiliser stock",
	303: "Manure stock",
	304: "Stock",
	305: "Stock transaction",
	306: "Stock location",
	307: "Stock supplier",
	401: "Seed plan",
	402: "Seed plan map",
	501: "Nutrition requirements",
	502: "Nutrition plan",
	503: "Nutrition app zone",
	504: "N Max",
	505: "Nutrition balance",
	506: "Nutrition plan template",
	601: "Manure plan",
	602: "NVZ risk map",
	603: "Livestock",
	604: "Manure storage",
	605: "Manure export",
	701: "Field performance",
	801: "Report",
	802: "Reporting task",
	803: "Report map region",
	901: "Cost of production",
	902: "Cost of production cropping config",
	903: "Silo",
	904: "Power unit",
	905: "Implement",
	906: "Operation",
	907: "Operation group",
	908: "Harvested amount",
	1101: "Boundary import task",
	1102: "Layer import task",
	1103: "Analysis import task",
	1104: "Holding import/sync task",
	1105: "Field boundaries",
	1106: "Cropping boundaries",
	1107: "Layers",
	1108: "Documents",
	1201: "Field diary entry",
	1301: "Plans",
	1302: "Nutrition plans",
	1303: "Seed plans",
	1304: "Boundaries",
	1305: "Layers",
	1401: "Climate station",
	1402: "Growth stage",
	1403: "Climate-related risk",
	1501: "Satellite imagery task",
	1601: "Prescription plan",
	1602: "Prescription template",
	1701: "Spray plan",
	1702: "Ifs order",
}
const _PlanType = {
	1: "Seed rates plan",
	2: "Nutrition plan",
	3: "Generic product plan",
	4: "Prescription plan",
	5: "Spray plan",
	6: "Other",
	7: "Nutrition plan",
}
const _RegionId = {
	1: "England",
	2: "Scotland",
	3: "Wales",
	4: "Poland",
	5: "Hungary",
	6: "France",
	7: "Belgium",
	8: "Netherlands",
	9: "Germany",
	10: "Romania",
	11: "Bulgaria",
	12: "Spain",
	13: "Czechia",
	14: "Slovakia",
	15: "Italy",
	16: "Turkey",
	17: "Greece",
	18: "Albania",
	19: "Andorra",
	20: "Armenia",
	21: "Austria",
	22: "Azerbaijan",
	23: "Belarus",
	24: "Bosnia & Herzegovina",
	25: "Croatia",
	26: "Cyprus",
	27: "Denmark",
	28: "Estonia",
	29: "Finland",
	30: "Georgia",
	31: "Iceland",
	32: "Ireland/N Ireland",
	33: "Kazakhstan",
	34: "Kosovo",
	35: "Latvia",
	36: "Liechtenstein",
	37: "Lithuania",
	38: "Luxembourg",
	39: "Malta",
	40: "Moldova",
	41: "Monaco",
	42: "Montenegro",
	43: "North Macedonia",
	44: "Norway",
	45: "Portugal",
	46: "Russia",
	47: "San Marino",
	48: "Serbia",
	49: "Sweden",
	50: "Switzerland",
	51: "Ukraine",
}
const _RiskRegionId = {
	1: "East",
	2: "Midlands",
	3: "North",
	4: "North East",
	5: "North West",
	6: "South",
	7: "South East",
	8: "South West",
	9: "West",
	40: "Wales",
	50: "Scotland East",
	51: "Scotland North",
	52: "Scotland West",
}
const _SatImageType = {
	1: "NDVI",
	2: "RGB",
	3: "CHI",
	4: "EVI",
	101: "NDVI (Planet)",
	102: "RGB (Planet)",
	103: "CHI (Planet)",
}
const _SoilAnalysisLayerSubtype = {
	1: "Soil analysis",
	2: "Grid samples",
}
const _SoilAnalysisType = {
	0: "Standard",
	1: "SSM",
}
const _SoilCategory = {
	1: "Light",
	2: "Medium",
	3: "Heavy",
	4: "Silt",
	5: "Organic",
	6: "Peat",
}
const _SoilErosionRisk = {
	1: "Low",
	2: "Low-moderate",
	3: "Moderate",
	4: "High",
	5: "Very high",
}
const _SoilP2O5Method = {
	1: "Olsen",
	2: "Morgan",
}
const _SoilTypeId = {
	1: "Clay",
	2: "Silty clay",
	3: "Silty clay loam",
	4: "Silty loam",
	5: "Sandy silt loam",
	6: "Clay loam",
	7: "Sandy clay",
	8: "Sandy clay loam",
	9: "Sandy loam",
	10: "Loamy sand",
	11: "Sand",
	12: "Organic",
	13: "Peat",
}
const _SprayQuality = {
	1: "Coarse",
	2: "Medium/Coarse",
	3: "Medium",
	4: "Medium/Fine",
	5: "Fine",
	6: "Not applicable",
}
const _SsmClassId = {
	1: "Very low",
	2: "Low",
	3: "Optimum",
	4: "High",
	5: "Very high",
}
const _StockType = {
	1: "Seed",
	2: "Fertiliser",
	3: "Manure",
	4: "Crop protection",
}
const _SubsoilTypeId = {
	1: "Shallow soils",
	2: "Shallow over sandstone",
	3: "Chalk",
	4: "Limestone",
	5: "Sandstone/Sand",
	6: "Shale",
	7: "Silt",
	8: "Clay",
}
const _TradingContractType = {
	1: "Spot",
	2: "Forward",
}
const _WindErosionRisk = {
	1: "Is not prone",
	2: "May be prone",
	3: "Is prone",
	4: "Is very prone",
}
const _YieldLayerSubtype = {
	1: "Target yield",
	2: "Actual yield",
}
const _YieldPotentialCategory = {
	1: "Inconsistent yield",
	2: "Consistently good",
	3: "Inconsistently good",
	4: "Consistently acceptable",
	5: "Inconsistently poor",
	6: "Consistently poor",
}

function toArray(obj) { return Object.keys(obj).map((k: any) => ({ value: Number(k), text: obj[k] as string })) }

export const param = {
	BiomassLevel: () => toArray(_BiomassLevel),
	BiomassUnit: () => toArray(_BiomassUnit),
	BusinessId: () => toArray(_BusinessId),
	CropDisease: () => toArray(_CropDisease),
	CropMaltingOption: () => toArray(_CropMaltingOption),
	CropProtectionStatus: () => toArray(_CropProtectionStatus),
	CropPurpose: () => toArray(_CropPurpose),
	CropResidue: () => toArray(_CropResidue),
	DiseaseSensitivity: () => toArray(_DiseaseSensitivity),
	ExternalAppId: () => toArray(_ExternalAppId),
	FertiliserAppUnit: () => toArray(_FertiliserAppUnit),
	FertiliserLiquidUnit: () => toArray(_FertiliserLiquidUnit),
	FieldAreaType: () => toArray(_FieldAreaType),
	FieldDrainage: () => toArray(_FieldDrainage),
	GenericPlanUnitId: () => toArray(_GenericPlanUnitId),
	GrassCuts: () => toArray(_GrassCuts),
	GrassManagementEngland: () => toArray(_GrassManagementEngland),
	GrassManagementScotland: () => toArray(_GrassManagementScotland),
	GrassNCropGroup: () => toArray(_GrassNCropGroup),
	GrassSiteClass: () => toArray(_GrassSiteClass),
	GrowingSeasonLength: () => toArray(_GrowingSeasonLength),
	HeadlandIncreaseUnit: () => toArray(_HeadlandIncreaseUnit),
	ImportHistoryProvider: () => toArray(_ImportHistoryProvider),
	LayerTypeGroupId: () => toArray(_LayerTypeGroupId),
	LayerTypeId: () => toArray(_LayerTypeId),
	LayerTypeSubgroupId: () => toArray(_LayerTypeSubgroupId),
	LimingFactor: () => toArray(_LimingFactor),
	ManureAppMethod: () => toArray(_ManureAppMethod),
	ManureUnit: () => toArray(_ManureUnit),
	NitrogenAnalysisType: () => toArray(_NitrogenAnalysisType),
	NitrogenSnsMethod: () => toArray(_NitrogenSnsMethod),
	NLeafAnalysis: () => toArray(_NLeafAnalysis),
	NMaxGroupId: () => toArray(_NMaxGroupId),
	NtrReqConfigMode: () => toArray(_NtrReqConfigMode),
	NutrientType: () => toArray(_NutrientType),
	OmniaModuleId: () => toArray(_OmniaModuleId),
	OmniaObjectType: () => toArray(_OmniaObjectType),
	PlanType: () => toArray(_PlanType),
	RegionId: () => toArray(_RegionId),
	RiskRegionId: () => toArray(_RiskRegionId),
	SatImageType: () => toArray(_SatImageType),
	SoilAnalysisLayerSubtype: () => toArray(_SoilAnalysisLayerSubtype),
	SoilAnalysisType: () => toArray(_SoilAnalysisType),
	SoilCategory: () => toArray(_SoilCategory),
	SoilErosionRisk: () => toArray(_SoilErosionRisk),
	SoilP2O5Method: () => toArray(_SoilP2O5Method),
	SoilTypeId: () => toArray(_SoilTypeId),
	SprayQuality: () => toArray(_SprayQuality),
	SsmClassId: () => toArray(_SsmClassId),
	StockType: () => toArray(_StockType),
	SubsoilTypeId: () => toArray(_SubsoilTypeId),
	TradingContractType: () => toArray(_TradingContractType),
	WindErosionRisk: () => toArray(_WindErosionRisk),
	YieldLayerSubtype: () => toArray(_YieldLayerSubtype),
	YieldPotentialCategory: () => toArray(_YieldPotentialCategory),
}


export const labels = {
	BiomassLevel: (key: number) => _BiomassLevel[key],
	BiomassUnit: (key: number) => _BiomassUnit[key],
	BusinessId: (key: number) => _BusinessId[key],
	CropDisease: (key: number) => _CropDisease[key],
	CropMaltingOption: (key: number) => _CropMaltingOption[key],
	CropProtectionStatus: (key: number) => _CropProtectionStatus[key],
	CropPurpose: (key: number) => _CropPurpose[key],
	CropResidue: (key: number) => _CropResidue[key],
	DiseaseSensitivity: (key: number) => _DiseaseSensitivity[key],
	ExternalAppId: (key: number) => _ExternalAppId[key],
	FertiliserAppUnit: (key: number) => _FertiliserAppUnit[key],
	FertiliserLiquidUnit: (key: number) => _FertiliserLiquidUnit[key],
	FieldAreaType: (key: number) => _FieldAreaType[key],
	FieldDrainage: (key: number) => _FieldDrainage[key],
	GenericPlanUnitId: (key: number) => _GenericPlanUnitId[key],
	GrassCuts: (key: number) => _GrassCuts[key],
	GrassManagementEngland: (key: number) => _GrassManagementEngland[key],
	GrassManagementScotland: (key: number) => _GrassManagementScotland[key],
	GrassNCropGroup: (key: number) => _GrassNCropGroup[key],
	GrassSiteClass: (key: number) => _GrassSiteClass[key],
	GrowingSeasonLength: (key: number) => _GrowingSeasonLength[key],
	HeadlandIncreaseUnit: (key: number) => _HeadlandIncreaseUnit[key],
	ImportHistoryProvider: (key: number) => _ImportHistoryProvider[key],
	LayerTypeGroupId: (key: number) => _LayerTypeGroupId[key],
	LayerTypeId: (key: number) => _LayerTypeId[key],
	LayerTypeSubgroupId: (key: number) => _LayerTypeSubgroupId[key],
	LimingFactor: (key: number) => _LimingFactor[key],
	ManureAppMethod: (key: number) => _ManureAppMethod[key],
	ManureUnit: (key: number) => _ManureUnit[key],
	NitrogenAnalysisType: (key: number) => _NitrogenAnalysisType[key],
	NitrogenSnsMethod: (key: number) => _NitrogenSnsMethod[key],
	NLeafAnalysis: (key: number) => _NLeafAnalysis[key],
	NMaxGroupId: (key: number) => _NMaxGroupId[key],
	NtrReqConfigMode: (key: number) => _NtrReqConfigMode[key],
	NutrientType: (key: number) => _NutrientType[key],
	OmniaModuleId: (key: number) => _OmniaModuleId[key],
	OmniaObjectType: (key: number) => _OmniaObjectType[key],
	PlanType: (key: number) => _PlanType[key],
	RegionId: (key: number) => _RegionId[key],
	RiskRegionId: (key: number) => _RiskRegionId[key],
	SatImageType: (key: number) => _SatImageType[key],
	SoilAnalysisLayerSubtype: (key: number) => _SoilAnalysisLayerSubtype[key],
	SoilAnalysisType: (key: number) => _SoilAnalysisType[key],
	SoilCategory: (key: number) => _SoilCategory[key],
	SoilErosionRisk: (key: number) => _SoilErosionRisk[key],
	SoilP2O5Method: (key: number) => _SoilP2O5Method[key],
	SoilTypeId: (key: number) => _SoilTypeId[key],
	SprayQuality: (key: number) => _SprayQuality[key],
	SsmClassId: (key: number) => _SsmClassId[key],
	StockType: (key: number) => _StockType[key],
	SubsoilTypeId: (key: number) => _SubsoilTypeId[key],
	TradingContractType: (key: number) => _TradingContractType[key],
	WindErosionRisk: (key: number) => _WindErosionRisk[key],
	YieldLayerSubtype: (key: number) => _YieldLayerSubtype[key],
	YieldPotentialCategory: (key: number) => _YieldPotentialCategory[key],
}

